import { useState } from "react";
import Alert from "components/common/Alert";
import ProductCategoryForm from "./ProductCategoryForm";

export default function ProductCategoryModal({
  initialData,
  onSubmit,
  onClose,
}) {
  const [modalError, setModalError] = useState("");

  return (
    <div className="p-2">
      {modalError && (
        <Alert
          type="error"
          message={modalError}
          onClose={() => setModalError("")}
        />
      )}

      <ProductCategoryForm
        initialData={initialData}
        onSubmit={(payload) => onSubmit(payload, setModalError)}
      />
    </div>
  );
}
